export default function Phase2() {
  return (
    <>
      <h2 className="cs-h2 cs-h2-tight">
        Phase 2: Meta Advertising Campaign Architecture
      </h2>

       <h3 className="cs-h3">
       Campaign Objective
      </h3>


       <p className="cs-p">
            Generate qualified leads from prospects with demonstrated capacity to invest in premium interior design services while systematically excluding unqualified inquiries through precision targeting.
      </p>

      <h3 className="cs-h3">
            ABO (Ad Set Budget Optimization) Strategy

      </h3>


       <p className="cs-p">
            Rather than using Campaign Budget Optimization (CBO), we implemented Ad Set Budget Optimization to maintain granular control over spending across different audience segments and creative variations. This approach allowed us to identify highest-performing combinations and allocate budget strategically rather than allowing Meta's algorithm to distribute funds automatically.
            Campaign structure included separate ad sets for each job title segment, individual budgets enabling performance comparison, rapid testing and optimization capability, and strategic budget reallocation based on lead quality metrics, not just volume.
        </p>



        <h3 className="cs-h3">
           Precision Targeting Framework
        </h3>


       <p className="cs-p">
            We developed multi-layered targeting criteria designed to reach decision-makers with financial capacity while excluding unqualified audiences:
       </p>

        <h3 className="cs-h3">
           Primary Targeting: Job Title Segmentation

        </h3>


       <p className="cs-p">
            Ad Set 1 - Senior Corporate Executives: Job titles including CEO, Managing Director, Director, Vice President, Senior Vice President, Chief Operating Officer, Chief Financial Officer. Demographics of age 35-55, income level signals (though not directly targetable, inferred through job titles and behaviors). Interest layering included luxury real estate, premium home décor, architecture and design publications.
            Ad Set 2 - Business Owners & Entrepreneurs: Job titles of Founder, Co-Founder, Entrepreneur, Business Owner, Managing Partner. Behaviors indicating business page admin, small business owner designation. Interest overlay of luxury lifestyle, premium brands, high-end home improvement.
            Ad Set 3 - Medical Professionals: Job titles including Doctor, Physician, Surgeon, Dentist, Medical Director, Hospital Administrator. Location targeting specific to Hyderabad's affluent neighborhoods (Jubilee Hills, Banjara Hills, Gachibowli, Madhapur, Kondapur). Interest alignment with premium lifestyle, healthcare management publications.
            Ad Set 4 - Tech & IT Leadership: Job titles of Engineering Manager, Product Manager, Technical Director, CTO, IT Director (Hyderabad's large tech sector). Company size targeting at 200+ employees indicating senior positions. Interest layering with smart home technology, modern design, tech publications.
            Ad Set 5 - Real Estate & Construction Leaders: Job titles including Real Estate Developer, Property Developer, Construction Company Owner, Real Estate Investor. Direct relevance to interior design needs through both personal and professional projects.
        </p>

         <h3 className="cs-h3">
           Exclusion Targeting (Critical for Junk Lead Removal)
        </h3>


       <p className="cs-p">
            We implemented aggressive exclusion criteria to filter out non-qualifying audiences: excluded job titles such as Student, Intern, Entry Level, Assistant, Associate, Junior, Trainee; excluded interests indicating budget focus like DIY home improvement, budget decorating, discount furniture, home improvement on a budget; excluded behaviors showing information-seeking without buying intent; and excluded demographics like age ranges typically lacking project budget capacity (18-28).
       </p>

        <h3 className="cs-h3">
           Geographic Precision
        </h3>


       <p className="cs-p">
            Rather than broad Hyderabad targeting, we focused on specific affluent areas: primary targeting of Jubilee Hills, Banjara Hills, Gachibowli, Kondapur, Madhapur, Nanakramguda, Kokapet, Financial District; secondary targeting of Manikonda, Narsingi, Puppalaguda, Tellapur; and exclusion of areas with predominantly budget-conscious demographics.
       </p>


       <h3 className="cs-h3">
           Behavioral & Interest Layering
        </h3>


       <p className="cs-p">
            Additional targeting refinement included recently moved or moving soon (project timing signals), engaged shoppers for luxury goods, interest in premium furniture brands (Godrej Interio, Evok, Urban Ladder premium), engagement with luxury real estate content, followers of premium interior design publications and influencers, and engagement with architecture and high-end construction content.
       </p>


        <h3 className="cs-h3">
           Andromeda Algorithm Alignment
        </h3>


       <p className="cs-p">
Meta's Andromeda update emphasized authentic content and meaningful engagement. Our strategy aligned by prioritizing UGC, FGC, and EGC content in ad creative rather than polished commercial content, using conversational ad copy reflecting real client language and concerns, featuring genuine client testimonials and project stories, encouraging meaningful engagement through questions and discussion in comments, and optimizing for quality engagement metrics (comment depth, save rate, share rate) over vanity metrics.
The algorithm rewarded authentic content with better organic reach and lower CPMs, creating compounding efficiency gains.
       </p>

        <h3 className="cs-h3">
           Campaign Creative Strategy

        </h3>

         <h4 className="cs-h3">
          Ad Format Mix:
        </h4>


       <p className="cs-p">
        Carousel Ads: Before-and-after project transformations, design process stages, portfolio showcases across multiple rooms.
        Video Ads: Client testimonial videos (UGC), founder explaining design approach (FGC), project walkthrough reveals showing completed spaces.
        Single Image Ads: High-impact room photography with strong design statements, specific service offerings with clear investment ranges.
      </p>


         <h3 className="cs-h3">
          Ad Copy Framework:
        </h3>


        <p className="cs-p">
       Hook: Address specific pain point or aspiration relevant to target audience ("Designing your dream home but overwhelmed by contractor quotes and Pinterest boards?").
        Value Proposition: Clear articulation of Aruh Koncepts' differentiation and approach ("We transform spaces through strategic design and meticulous execution—handling everything from concept to installation").
        Social Proof: Specific client results or testimonials ("Delivered 40+ premium residential projects across Hyderabad's finest addresses").
        Qualification: Subtle budget indicators to filter leads ("Our full-home design projects start at ₹15L, ensuring comprehensive transformation with premium materials and expert execution").
        Call-to-Action: Clear next step with mild friction ("Book a design consultation to discuss your project. Share your requirements and budget for personalized proposal").
        </p>

         <h3 className="cs-h3">
         Budget Qualification Messaging:
        </h3>

         <p className="cs-p">
        Rather than hiding investment requirements, we transparently communicated budget ranges within ad creative and landing pages. This approach decreased lead volume but dramatically improved lead quality by self-selecting prospects with appropriate expectations.
        Example messaging: "Premium residential interiors: ₹15L-₹50L+ depending on scope," "Commercial interiors starting at ₹25L for 2000 sq ft," "Design consultation fee: ₹25,000 (adjustable against project)."
         </p>


          <h3 className="cs-h3">
         Lead Form Optimization
        </h3>

         <p className="cs-p">
        Custom lead forms included qualification questions: project type (full home, specific rooms, commercial), project timeline (immediate, 3-6 months, 6-12 months, research phase), approximate budget range (₹5-10L, ₹10-15L, ₹15-25L, ₹25L+), project address/area, and current stage (purchased property, under construction, ready to occupy, planning phase).
        Forms strategically added friction to discourage casual inquiries while collecting essential qualification data. Higher form completion requirements reduced junk leads significantly.
         </p>









      {/* Entire Phase 2 content */}
    </>
  );
}